export enum PreviewType {
  Preview2D = 'preview2D',
  Preview3D = 'preview3D',
}
